import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label } from '../';
import styled, { css } from 'styled-components';
import { colors } from '../theme';
import { HeaderList, MIN_WIDTH_HOMEPAGE_DESKTOP, MIN_WIDTH_DESKTOP } from '../header-v2';
import GetQuotesButton from './get-quotes-button';
import HamburgerMenu from './header-menu-v2';

const GA_CATEGORY = 'Header Menu';

export const HeaderLink = styled.a`
  display: none;

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    font-size: 15px;
    color: #333;
    text-decoration: none;
    color: ${colors.MEDIUM_DARK_GREY};
    padding: 10px 15px 10px 0;
    display: inline-block;

    &:hover,
    &:visited {
      color: #555;
    }

    ${props =>
      props.primary &&
      css`
        color: ${props.theme.primary};
        &:hover,
        &:visited {
          color: ${props.theme.primary};
        }
      `};
  }

  @media (min-width: 1008px) {
    padding: 10px 20px 10px 0;
  }
`;

export const HeaderGQButton = styled.div`
  display: none;

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    display: inline-block;
    padding-right: 22px;
  }
`;

export default class LoggedOut extends Component {
  static propTypes = {
    isHomepage: PropTypes.bool,
    siteSource: PropTypes.string,
    loginData: PropTypes.object
  };

  render() {
    const { isHomepage, siteSource, loginData } = this.props;

    return (
      <HeaderList style={{ float: 'right' }}>
        <HeaderLink
          href="/login"
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Login`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          data-label={'header-sign-in'}
          isHomepage={isHomepage}
        >
          Sign In
        </HeaderLink>
        <HeaderLink
          href="/advertise"
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked List Your Business`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          isHomepage={isHomepage}
          data-label={'header-list-your-business'}
        >
          <Label
            secondary
            style={{ letterSpacing: 'initial', textTransform: 'none', fontSize: 15 }}
          >
            List your Business
          </Label>
        </HeaderLink>
        <HamburgerMenu loginData={loginData} isHomepage={isHomepage} siteSource={siteSource} />

        <HeaderGQButton isHomepage={isHomepage}>
          <GetQuotesButton siteSource={siteSource}>Get Quotes</GetQuotesButton>
        </HeaderGQButton>
      </HeaderList>
    );
  }
}
